export function initialFocus() {
    const h1 = document.querySelector<HTMLHeadingElement>('#content h1');
    if (h1) {
        h1.tabIndex = -1;
        h1.focus();
    }
}
